export const InvoiceForm = () => ({
  isInvoiceFormValid: true,

  validationState: {
    mobile_carrier: { isValid: true, isDefault: false },
    company_vat: { isValid: true, isDefault: false },
    vat_invoice: { isValid: true, isDefault: false },
    e_invoice: { isValid: true, isDefault: false },
  },

  init() {
    this.validateForm()
    
    this.$el.addEventListener("carrier-validation-changed", (event) => {
      this.handleValidationChange("mobile_carrier", event.detail)
    })

    this.$el.addEventListener("vat-validation-changed", (event) => {
      this.handleValidationChange("company_vat", event.detail)
    })



    this.$el.addEventListener("e-invoice-validation-changed", (event) => {
      this.handleValidationChange("e_invoice", event.detail)
    })

    const radioButtons = this.$el.querySelectorAll('input[type="checkbox"]')
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.updateDefaultStates()
      })
    })
  },

  handleValidationChange(fieldName, detail) {
    this.validationState[fieldName] = detail
    this.validateForm()
  },

  updateDefaultStates() {
    const defaultCheckboxes = this.$el.querySelectorAll('input[type="checkbox"]')

    Object.keys(this.validationState).forEach((key) => {
      this.validationState[key].isDefault = false
    })

    defaultCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const method = checkbox.value
        if (this.validationState[method]) {
          this.validationState[method].isDefault = true
        }
      }
    })

    this.validateForm()
  },

  validateForm() {
    let allFieldsValid = true

    Object.values(this.validationState).forEach((state) => {
      if (state.isDefault && !state.isValid) {
        allFieldsValid = false
      }
    })

    this.isInvoiceFormValid = allFieldsValid
  },
})
